
export function UsefulOrthoLinks() {
  const bullet = '\u2022 ';
  return (<>
    Phonetics:<br />
    {bullet} <a href='?page=chart-essay'>Phoneme Charts</a>
    <br />
    {bullet} <a href='?page=speech-essay'>Picking Speech Phonemes</a>
    <br />
    {bullet} <a href='?page=rules-essay'>Sound Change Rules</a>
    <br /><br />
    <a href='?page=prime'>Main Page</a>
  </>)
}
